export const getVariantsAvailability = (variants, selectedSizeCode) => {
    const isUniqueSize = (variants === null || variants === void 0 ? void 0 : variants.length) === 1;
    const updatedVariants = variants === null || variants === void 0 ? void 0 : variants.map((variant) => ({
        code: variant.code,
        sizeName: variant.size.name,
        sizeCode: variant.size.sizeCode,
        inStock: variant.stock.stockLevel === 1,
        hasFewPiecesLeft: variant.fewPieceLeft,
        isOutOfStock: variant.stock.stockLevel === 0,
        isSelected: isUniqueSize ? true : variant.size.sizeCode === selectedSizeCode,
    }));
    return updatedVariants;
};
//# sourceMappingURL=getVariantsAvailability.js.map